import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';

@Injectable({
  providedIn: 'root'
})
export class OrganisationProfileSocialBalanceEntryApiService extends ApiService {
  readonly resourcePath = 'organisation_profile_social_balance_entries';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<any>> {
    return this.restList<any>(filters);
  }

  get(id: string): Observable<any> {
    return this.restRead<any>(id);
  }

  update(id: string, data: object): Observable<any> {
    return this.restUpdate<any>(id, data);
  }

  create(data: object) {
    return this.restCreate<any>(data);
  }
}
